import './src/App.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./src/styles/edge-hide.css";

import React from "react";
import { AuthProvider } from "./src/context/AuthContext";
import { FavouriteProvider } from "./src/context/FavouriteContext";

export const wrapRootElement = ({ element }) => (
	<AuthProvider> <FavouriteProvider>{element}</FavouriteProvider></AuthProvider>
);
